import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { I18nService } from '../../core/services/i18n.service';

export interface CardNameValidationErrors extends ValidationErrors {
  invalidCharacters?: { message: string };
  invalidLength?: { message: string };
}

export function cardNameValidator(i18nService: I18nService): ValidatorFn {
  return (control: AbstractControl): CardNameValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();
    
    if (!value) {
      return null;
    }

    // Verifica caracteres válidos (apenas letras e espaços)
    // Permite: letras (a-z, A-Z) e espaços
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return { 
        invalidCharacters: { 
          message: i18nService.instant('validators.cardName.invalidCharacters') 
        } 
      };
    }

    // Verifica o comprimento (2 a 64 caracteres)
    if (value.length < 2) {
      return { 
        invalidLength: { 
          message: i18nService.instant('validators.cardName.minLength')
        } 
      };
    }

    if (value.length > 64) {
      return { 
        invalidLength: { 
          message: i18nService.instant('validators.cardName.maxLength')
        } 
      };
    }

    return null;
  };
}
